import { createQueryKeys } from "@lukemorales/query-key-factory";
import Billing from "../Billing";

export const billing = createQueryKeys("billing", {
  getOverviewCards: null,
  getCompaniesList: (
    pageNumber?: number,
    pageSize?: number,
    searchText?: string,
    statusFilter?: string
  ) => ({
    queryKey: ["CompaniesList", { pageNumber, pageSize, searchText, statusFilter }],
    queryFn: () => Billing.getCompaniesList(pageNumber, pageSize, searchText, statusFilter),
  }),
  getChart: (month?: string, companyId?: number) => ({
    queryKey: ["Chart", { month, companyId }],
    queryFn: () => Billing.getChart(month, companyId),
  }),
  getSubscriptionData: (
    companyId?: number,
    month?: string,
    pageSize?: number,
    pageNumber?: number
  ) => ({
    queryKey: ["SubscriptionData", { companyId, month, pageSize, pageNumber }],
    queryFn: () =>
      Billing.getSubscriptionData(companyId, month, pageSize, pageNumber),
  }),
  getCompanyInvoices: (
    companyId?: number,
    month?: string,
    year?: string,
    pageSize?: number,
    pageNumber?: number
  ) => ({
    queryKey: ["CompanyInvoices", { companyId, month, year, pageSize, pageNumber }],
    queryFn: () =>
      Billing.getCompanyInvoices(companyId, month, year, pageSize, pageNumber),
  }),
});

